var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"movies"}},_vm._l((_vm.movies),function(item){return _c('movie-item',{key:item.id,attrs:{"movie":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }